export const educationData = [
    {
        degree: "Matriculation",
        institute: "Saraswati Vidya Mandir",
        score: "80%"
    },
    {
        degree: "Intermediate (12th)",
        institute: "UNIITECH",
        score: "63%"
    },
    {
        degree: "B.Sc. Honors",
        institute: "UDC College — with program distinction",
        score: "67%"
    },
    {
        degree: "MCA",
        institute: "BVICAM College",
        score: "87% aggregate"
    }
];
